import React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";

export default function BartjaStokut() {
    return (
        <Box sx={{ maxWidth: 960, mx: "auto", px: { xs: 2, sm: 3 }, py: { xs: 3, md: 5 } }}>
            <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.5 }}>
                Viti fiskal
            </Typography>
            <Typography component="h1" variant="h5" fontWeight={700} sx={{ mb: 3 }}>
                Bartja e Stokut Fillestar
            </Typography>

            <Paper variant="outlined" sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "none" }}>
                <Box sx={{ height: 4, bgcolor: "primary.main" }} />
                <Box sx={{ px: { xs: 2.5, sm: 5 }, py: { xs: 5, sm: 7 }, textAlign: "center" }}>
                    <Box sx={{
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        width: 88, height: 88, mb: 3, borderRadius: 4,
                        bgcolor: "action.hover", color: "primary.main",
                    }}>
                        <Inventory2OutlinedIcon sx={{ fontSize: 42 }} />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <Chip icon={<ConstructionOutlinedIcon />} label="Në zhvillim" size="small" variant="outlined" />
                    </Box>
                    <Typography component="h2" variant="h6" fontWeight={700} sx={{ mb: 1.5 }}>
                        Po përgatisim bartjen e stokut
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440, mx: "auto", lineHeight: 1.8 }}>
                        Kjo pjesë është në zhvillim dhe ende nuk është e disponueshme
                        për bartjen e stokut fillestar në vitin e ri fiskal.
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
}
